export const ButtonDark = ({ text, funcion, className}) => {
    return (
        <button type="button" className={'btn btn-dark rounded-5 my-4 py-3 ' + className} onClick={funcion}>{text}</button>
    );
}
